var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWipBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3B82F6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.4 22.1 21.4H1.9L7 1.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.9,
    r: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.2V12m0-2.7-2.5 1.6-.4-.1m3.7-1.5 4.05 1.2M10 12l-1.1 3.4M10 12l1.5 3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.2 6.2-2.55 10m1.75-9.75 1.7.45m-3.45 9.1 2.05.55-.45 1.55-2.05-.55.45-1.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWipBlue);
export default __webpack_public_path__ + "static/media/wip-blue.4e59bac7bc61597b48d49703523f1f5b.svg";
export { ForwardRef as ReactComponent };